import React, { useContext, useState } from "react";

//pages & includes
import ManageSidebar from "../ManageSidebar";

//functions
import {
  _t,
  getCookie,
  modalLoading,
  tableLoading,
  showingData,
  pagination,
  paginationLoading,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

import { BASE_URL } from "../../../../../BaseUrl";
import axios from "axios";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import { ExportToCsv } from 'export-to-csv';

//context consumer
import { SettingsContext } from "../../../../../contexts/Settings";
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import { confirmAlert } from "react-confirm-alert";
import CustomSpinLoader from "../../../../components/CustomSpinLoader";

const VoucherCrud = () => {
  // 3rd party hooks
  const { t } = useTranslation();

  // contexts
  const {
    //common
    loading,
    setLoading,
  } = useContext(SettingsContext);
  const {
    voucherList,
    setVoucherList,
    voucherForSearch,
    setVoucherForSearch,
    setPaginatedVoucher,
    getMasterVoucher,
  } = useContext(RestaurantContext);

  //csv import
  const options = {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalSeparator: '.',
    showLabels: true,
    useTextFile: false,
    useBom: true,
    useKeysAsHeaders: true,
    // headers: ['Name', 'Voc Number', 'Discount %'],
    filename: 'Voucher',
  };
  const csvExporter = new ExportToCsv(options);

  const [uploadCsv,setUploadCsv] = useState(null);
  const [uploadCsvModal,setUploadCsvModal] = useState(false);

  // states
  const [newVoucher, setNewVoucher] = useState({
    bank_name: "",
    iban_number: "",
    from_voucher: "",
    to_voucher: "",
    prefix_name: "",
    discount: "",
    id: null,
    edit: false,
    uploading: false,
  });
  const [searchedVoucher, setSearchedVoucher] = useState({
    list: [],
    searched: false,
  });

  const handleSearch = (e) => {
    const searchTerm = e.target.value;
    if (searchTerm) {
      const newList =
        voucherForSearch && voucherForSearch.length
          ? voucherForSearch.filter((card) => {
              if (!card || !Object.keys(card).length) return false;
              if (
                card.discount &&
                card.discount.toString().includes(searchTerm)
              )
                return true;
              if (
                card.bank_name &&
                card.bank_name.toLowerCase().includes(searchTerm)
              )
                return true;
              if (card?.from_voucher && card.from_voucher.includes(searchTerm))
                return true;
              if (card?.to_voucher && card.to_voucher.includes(searchTerm))
                return true;  
              return false;
            })
          : [];
      setSearchedVoucher({
        list: [...newList],
        searched: true,
      });
    } else {
      setSearchedVoucher({
        list: [],
        searched: false,
      });
    }
  };

  // state helpers
  const handleSetEdit = async (voucher) => {
    try {
      const url = BASE_URL + "/settings/voucher/" + (voucher.id ?? voucher.voucher_id);
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      if(res.data){
        setNewVoucher({
          bank_name: res.data.bank_name,
          iban_number: res.data?.iban_number || "",
          from_voucher: res.data.from_voucher,
          to_voucher: res.data.to_voucher,
          prefix_name: res.data.prefix,
          discount: res.data.discount,
          id: res.data.id,
          edit: true,
          uploading: false,
        });
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const handleSetNewVoucher = (e) => {
    e.persist();
    setNewVoucher((curr) => ({
      ...curr,
      [e.target.name]: e.target.value,
    }));
  };

  const clearNewVoucher = () => {
    setNewVoucher({
      bank_name: "",
      iban_number: "",
      from_voucher: "",
      to_voucher: "",
      prefix_name: "",
      discount: "",
      id: null,
      edit: false,
      uploading: false,
    });
  };

  const setNewData = (res) => {
    setVoucherList(res.data[0]);
    setVoucherForSearch(res.data[1]);
    setSearchedVoucher({
      searched: false,
      list: [],
    });
    setLoading(false);
  };

  const apiFailedToast = (err) => {
    setLoading(false);
    if(err.response?.data?.status === 0){
      toast.error(`${_t(t(err.response.data.message))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
      return
    }
    toast.error(`${_t(t("Please try again"))}`, {
      position: "bottom-center",
      autoClose: 10000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      className: "text-center toast-notification",
    });
  };

  // CREATE / UPDATE
  const handleSaveSeries = (e) => {
    e.preventDefault();

    if (
      !newVoucher.bank_name ||
      !newVoucher.discount ||
      !newVoucher.from_voucher
    ) {
      toast.error(`${_t(t("Please fill all the fields"))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
      return;
    }
    if (
      Number(newVoucher.prefix_name?.length) + Number(newVoucher.from_voucher?.length) < 8
    ) {
      toast.error(
        `${_t(t("Please enter 8 digit voucher (prefix + number)"))}`,
        {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        }
      );
      return;
    }
    setLoading(true);
    setNewVoucher({
      ...newVoucher,
      uploading: true,
    });

    const formData = {
      id: newVoucher.id,
      bank_name: newVoucher.bank_name,
      prefix_name: newVoucher.prefix_name,
      discount: newVoucher.discount,
      from_voucher: newVoucher.from_voucher,
      to_voucher: newVoucher.to_voucher,
    }

    const endPoint = newVoucher.id ? `/settings/voucher/${newVoucher.id}` : "/settings/voucher";
    const createUrl = BASE_URL + endPoint;
    const method = newVoucher.edit && newVoucher.id ? "put" : "post";
    
    axios[method](createUrl, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setNewData(res);
        toast.success(`${_t(t(`Voucher Series has been saved.`))}.`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        setLoading(false);
        setNewVoucher({
          ...newVoucher,
          uploading: false,
        });
        if(!newVoucher?.id){
          getMasterVoucher();
        }
        document.getElementById("close_btn").click();
      })
      .catch((err) => {
        setNewVoucher({
          ...newVoucher,
          uploading: false,
        });
        apiFailedToast(err);
      })
      .finally(clearNewVoucher);
  };

  // DELETE
  const handleDeleteConfirmation = (card) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="card card-body">
            <h1>{_t(t("Are you sure?"))}</h1>
            <p className="text-center">{_t(t("You want to delete this?"))}</p>
            <div className="d-flex justify-content-center">
              <button
                className="btn btn-primary rounded"
                onClick={() => {
                  handleDeleteVoucher(card.id);
                  onClose();
                }}
              >
                {_t(t("Yes, delete it!"))}
              </button>
              <button
                className="btn btn-success ml-2 px-3 rounded"
                onClick={onClose}
              >
                {_t(t("No"))}
              </button>
            </div>
          </div>
        );
      },
    });
  };
  const handleDeleteVoucher = async (id) => {
    setLoading(true);
    const deleteUrl = BASE_URL + `/settings/voucher/${id}`;
    return axios
      .delete(deleteUrl, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setNewData(res);
        toast.success(
          `${_t(t("Vocuher Information has been deleted successfully"))}`,
          {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          }
        );
      })
      .catch((err) => {
        apiFailedToast(err)
      })
      .finally(clearNewVoucher);
  };

  // import export csv
  const handleVoucherCsv = async() =>{
    const url = BASE_URL + `/settings/export-voucher-info`;
    try{
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      if(res.data){
        csvExporter.generateCsv(res.data);
        setLoading(false);
      }
    } catch (error){
      setLoading(false);
      toast.error(`${_t(t("Please try again"))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    }
  }
  
  function isCSV(contents) {
    // Basic check if it's a CSV file by checking if it contains a comma
    const rows = contents.split('\n');

    // Extract the header row (assuming it's the first row)
    const headerRow = rows[0];

    // Split the header row into individual header values
    const headers = headerRow.split(',');
    return contents.includes(',') && contents.includes('\n') && (headers.length === 3);
  }
  
  const handleOnChange = (e) => {
    if (e.target.files[0]) {
      const fileReader = new FileReader();
      fileReader.readAsText(e.target.files[0]);
      fileReader.onload = (e) => {
        const contents = e.target.result;
        
        if(isCSV(contents)){
          const startIndex = 1; // Start index
          const lines = contents.trim().split('\n').slice(startIndex);
          const parsedData = lines.map((line)=>{
            const values = line.split(',').map(value => value.replace(/["/\r\n]/g, ''));
            return {
              master : values[0],
              voucher_no : values[1],
              discount : values[2],
            }
          })
          setUploadCsv(parsedData);
        }else {  
          if (document.getElementById('uploadFile')) {
            document.getElementById('uploadFile').value = '';
          }
          setUploadCsv(null)
          setUploadCsvModal(false)
          toast.error("Please upload only voucher csv file", {
            position: "bottom-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          }); 
        } 
      };
    }; 
  }
  
  const handleVoucherCsvSubmit = async(e) => {
    e.preventDefault();
    
    const url = BASE_URL +"/settings/import-voucher-info";
    let formData = {
      voucher : uploadCsv
    }
    if(!uploadCsv || uploadCsv.length === 0){
      toast.error(`${_t(t("Please upload file"))}`, {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
      return false
    }

    setLoading(true);
    try{
      const res = await axios.post(url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      if(res.data){
        if (document.getElementById('uploadFile')) {
          document.getElementById('uploadFile').value = '';
        }
        setUploadCsv(null);
        setUploadCsvModal(false)
        setLoading(false);
        if(res.data.status === 0){
          toast.success(`${_t(t(res.data.message + (res.data.skipped_ibans ? res.data.skipped_ibans : "")))} `, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
          return
        }
        toast.success(`${_t(t("Voucher file upload successfully"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      }
    }catch (error){
      setLoading(false);
      setUploadCsv(null);
      toast.error(`${_t(t("Please try again"))}`, {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    }
  }  

  return (
    <>
      <Helmet>
        <title>{_t(t("Voucher Setting"))}</title>
      </Helmet>

      {/* add voucher modal */}
      <div className="modal fade" id="addVoucher" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header align-items-center">
              <div className="fk-sm-card__content">
                <h5 className="text-capitalize fk-sm-card__title">
                  {!newVoucher.edit
                    ? _t(t("Add Series Voucher Number"))
                    : _t(t("Update Series Voucher Number"))}
                </h5>
              </div>
              <button
                type="button"
                id="close_btn"
                className="btn-close"
                data-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {!newVoucher.uploading ? (
                <div key="fragment-card">
                  <form onSubmit={handleSaveSeries} autoComplete="off">
                    <div className="row">
                      <div className="mt-4 col-6">
                        <label htmlFor="bank_name" className="form-label">
                          {_t(t("Offer Name"))}
                          <small className="text-danger">*</small>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="bank_name"
                          id="bank_name"
                          placeholder="e.g. Voucher, Offer"
                          value={
                            newVoucher.bank_name ? newVoucher.bank_name : ""
                          }
                          required
                          onChange={handleSetNewVoucher}
                        />
                      </div>
                      <div className="mt-4 col-6">
                        <label htmlFor="prefix" className="form-label">
                          {_t(t("Prefix Name"))}
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="prefix_name"
                          id="prefix"
                          placeholder="e.g. restaurant"
                          value={
                            newVoucher.prefix_name ? newVoucher.prefix_name : ""
                          }
                          onChange={handleSetNewVoucher}
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="mt-4 col-6">
                        <label htmlFor="from_voucher" className="form-label">
                          {_t(t("From Voucher Number"))}
                          <small className="text-danger">*</small>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="from_voucher"
                          id="from_voucher"
                          placeholder="e.g. 123456..."
                          value={
                            newVoucher.from_voucher
                              ? newVoucher.from_voucher
                              : ""
                          }
                          required
                          onChange={handleSetNewVoucher}
                          maxLength={15}
                        />
                      </div>

                      <div className="mt-4 col-6">
                        <label htmlFor="to_voucher" className="form-label">
                          {_t(t("To Voucher Number"))}
                          <small className="text-danger">*</small>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="to_voucher"
                          id="to_voucher"
                          placeholder="e.g. 123456..."
                          value={
                            newVoucher.to_voucher ? newVoucher.to_voucher : ""
                          }
                          required
                          onChange={handleSetNewVoucher}
                          maxLength={15}
                        />
                      </div>
                    </div>
                    <div className="mt-4">
                      <label htmlFor="discount" className="form-label">
                        {_t(t("Discount In Percentage"))}
                        <small className="text-danger">*</small>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        min="0"
                        name="discount"
                        id="discount"
                        placeholder="e.g. 15"
                        value={newVoucher.discount ? newVoucher.discount : ""}
                        required
                        onChange={handleSetNewVoucher}
                      />
                    </div>
                    <div className="row mt-4 d-flex justify-content-end">
                      <div className="col-3">
                        <button
                          type="submit"
                          className="btn btn-success w-100 xsm-text text-uppercase t-width-max rounded"
                          // onClick={(e) => {
                          //   e.preventDefault();
                          // }}
                        >
                          {!newVoucher.edit ? _t(t("Save")) : _t(t("Update"))}
                        </button>
                      </div>
                      <div className="col-3">
                        <button
                          type="button"
                          className="btn btn-primary w-100 xsm-text text-uppercase t-width-max rounded"
                          data-dismiss="modal"
                          onClick={clearNewVoucher}
                        >
                          {_t(t("Close"))}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              ) : (
                <div key="fragment2">
                  <div className="text-center text-primary font-weight-bold text-uppercase">
                    {_t(t("Please wait"))}
                  </div>
                  {modalLoading(3)}
                  <div className="mt-4">
                    <div className="row d-flex justify-content-end">
                      <div className="col-3">
                        <button
                          type="button"
                          className="btn btn-success w-100 xsm-text text-uppercase t-width-max rounded"
                          onClick={(e) => {
                            e.preventDefault();
                          }}
                          disabled
                        >
                          {!newVoucher.edit ? _t(t("Save")) : _t(t("Update"))}
                        </button>
                      </div>
                      <div className="col-3">
                        <button
                          type="button"
                          className="btn btn-primary w-100 xsm-text text-uppercase t-width-max rounded"
                          data-dismiss="modal"
                          disabled
                        >
                          {_t(t("Close"))}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/*upload csv Modal*/}
      <div
        className={`modal fade ${uploadCsvModal !== false ? "showing" : ""}`}
        id="addReason"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-header align-items-center">
              <div className="fk-sm-card__content"></div>
              <button
                type="button"
                className="btn-close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={(e) => {
                  if (document.getElementById('uploadFile')) {
                    document.getElementById('uploadFile').value = '';
                  }
                  setUploadCsv(null)
                  setUploadCsvModal(false)
                }}
              ></button>
            </div>
            <div className="modal-body">
              {/* show form or show saving loading */}
              <div key="fragment-food-group-1">
                <form onSubmit={handleVoucherCsvSubmit} autoComplete="off">
                  <div>
                    <label htmlFor="name" className="form-label">
                      {_t(t("Upload File"))}{" "}
                      <small style={{ color: "red" }}>*</small>
                    </label>
                    <br/>
                    <input
                      type={"file"}
                      id="uploadFile"
                      name="uploadFile"
                      accept={".csv"}
                      onChange={handleOnChange}
                    />
                  </div>
                  <button
                  disbaled={loading}
                  type="submit"
                  className="btn btn-primary xsm-text text-uppercase px-3 py-2 my-4 rounded"
                  >
                    {_t(t("Submit"))}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ManageSidebar />
            </div>

            {/* main content */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div className="fk-scroll--pos-table-menu" data-simplebar>
                  <div className="t-pl-15 t-pr-15">
                    {/* {loading ? (
                      tableLoading()
                    ) : ( */}
                    <div key="fragment3">
                      {/* spinner */}
                      <CustomSpinLoader loading={loading} />
                      {/* top search */}
                      <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                        <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0 d-flex justify-content-between">
                          <ul className="t-list fk-breadcrumb">
                            <li className="fk-breadcrumb__list">
                              <span className="t-link fk-breadcrumb__link text-capitalize">
                                {!searchedVoucher.searched
                                  ? _t(t("Voucher List"))
                                  : _t(t("Search Result"))}
                              </span>
                            </li>
                          </ul>
                          <div>
                            <button title="Download voucher in excel" className="btn btn-success btn-sm text-uppercase sm-text mr-2 rounded" onClick={()=>handleVoucherCsv()} >Export Csv <i className="fa fa-download"></i></button>
                            <button title="Upload voucher in excel" className="btn btn-primary btn-sm text-uppercase sm-text rounded" onClick={()=>setUploadCsvModal(true)}>Import Csv <i className="fa fa-upload"></i></button>
                          </div> 
                        </div>
                        <div className="col-md-6 col-lg-7">
                          <div className="row gx-3 align-items-center">
                            <div className="col-md-3"></div>
                            {/* Search group */}
                            <div className="col-md-6 t-mb-15 mb-md-0">
                              <div className="input-group">
                                <div className="form-file">
                                  <input
                                    type="text"
                                    className="form-control border-0 form-control--light-1 rounded-left"
                                    placeholder={
                                      _t(
                                        t("Search by name, discount and IBAN")
                                      ) + ".."
                                    }
                                    onChange={handleSearch}
                                  />
                                </div>
                                <button
                                  className="btn btn-primary rounded-right"
                                  type="button"
                                >
                                  <i
                                    className="fa fa-search"
                                    aria-hidden="true"
                                  ></i>
                                </button>
                              </div>
                            </div>

                            {/* Add group modal trigger button */}
                            <div className="col-md-3 text-md-right">
                              <button
                                type="button"
                                className="btn btn-primary xsm-text text-uppercase btn-lg btn-block rounded"
                                data-toggle="modal"
                                data-target="#addVoucher"
                                onClick={() => clearNewVoucher()}
                              >
                                {_t(t("add new voucher"))}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Table */}
                      <div className="table-responsive">
                        <table className="table table-bordered table-hover">
                          <thead className="align-middle">
                            <tr>
                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("S/L"))}
                              </th>

                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("Name"))}
                              </th>

                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("Discount"))}
                              </th>

                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("Prefix"))}
                              </th>

                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("From Voucher"))}
                              </th>

                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("To Voucher"))}
                              </th>

                              <th
                                scope="col"
                                className="sm-text text-capitalize align-middle text-center border-1 border"
                              >
                                {_t(t("Action"))}
                              </th>
                            </tr>
                          </thead>
                          <tbody className="align-middle">
                            {!searchedVoucher.searched ? (
                              !voucherList ||
                              !voucherList.data ||
                              !voucherList.data.length ? (
                                <tr className="align-middle">
                                  <td
                                    scope="row"
                                    colSpan="6"
                                    className="xsm-text align-middle text-center"
                                  >
                                    {_t(t("No data available"))}
                                  </td>
                                </tr>
                              ) : (
                                voucherList.data.map((voucher, index) => (
                                  <tr className="align-middle" key={index}>
                                    <th
                                      scope="row"
                                      className="xsm-text text-capitalize align-middle text-center"
                                    >
                                      {index +
                                        1 +
                                        (voucherList.current_page - 1) *
                                          voucherList.per_page}
                                    </th>
                                    <td className="xsm-text text-capitalize align-middle text-center">
                                      {voucher.bank_name}
                                    </td>
                                    <td className="xsm-text text-capitalize align-middle text-center">
                                      {voucher.discount}
                                    </td>
                                    <td className="xsm-text text-capitalize align-middle text-center">
                                      {voucher.prefix}
                                    </td>
                                    <td className="xsm-text text-capitalize align-middle text-center">
                                      {voucher.from_voucher}
                                    </td>
                                    <td className="xsm-text align-middle text-center">
                                      {voucher.to_voucher}
                                    </td>
                                    <td className="xsm-text text-capitalize align-middle text-center">
                                      {/* <div className="dropdown">
                                        <button
                                          className="btn t-bg-clear t-text-dark--light-40"
                                          type="button"
                                          data-toggle="dropdown"
                                        >
                                          <i className="fa fa-ellipsis-h"></i>
                                        </button>
                                        <div className="dropdown-menu">
                                          <button
                                            className="dropdown-item sm-text text-capitalize"
                                            onClick={() =>
                                              handleSetEdit(voucher)
                                            }
                                            data-toggle="modal"
                                            data-target="#addCard"
                                          >
                                            <span className="t-mr-8">
                                              <i className="fa fa-pencil"></i>
                                            </span>
                                            {_t(t("Edit"))}
                                          </button>
                                          <button
                                            className="dropdown-item sm-text text-capitalize"
                                            onClick={() =>
                                              handleDeleteConfirmation(voucher)
                                            }
                                          >
                                            <span className="t-mr-8">
                                              <i className="fa fa-trash"></i>
                                            </span>
                                            {_t(t("Delete"))}
                                          </button>
                                        </div>
                                      </div> */}
                                      <button
                                        className="btn btn-primary ml-2 rounded-sm del-btn"
                                        onClick={() => handleSetEdit(voucher)}
                                        data-toggle="modal"
                                        data-target="#addVoucher"
                                      >
                                        <i
                                          className="fa fa-pencil edit-icon"
                                          aria-hidden="true"
                                        ></i>
                                      </button>
                                      {/* <button
                                        className="btn btn-danger ml-2 rounded-sm del-btn"
                                        onClick={() =>
                                          handleDeleteConfirmation(voucher)
                                        }
                                      >
                                        <MdDelete className="del-icon" />
                                      </button> */}
                                    </td>
                                  </tr>
                                ))
                              )
                            ) : !searchedVoucher ||
                              !searchedVoucher.list ||
                              !searchedVoucher.list.length ? (
                              <tr className="align-middle">
                                <td
                                  scope="row"
                                  colSpan="6"
                                  className="xsm-text align-middle text-center"
                                >
                                  {_t(t("No data available"))}
                                </td>
                              </tr>
                            ) : (
                              searchedVoucher.list.map((voucher, index) => (
                                <tr className="align-middle" key={index}>
                                  <th
                                    scope="row"
                                    className="xsm-text text-capitalize align-middle text-center"
                                  >
                                    {index +
                                      1 +
                                      (voucherList.current_page - 1) *
                                        voucherList.per_page}
                                  </th>
                                  <td className="xsm-text text-capitalize align-middle text-center">
                                    {voucher.bank_name}
                                  </td>
                                  <td className="xsm-text text-capitalize align-middle text-center">
                                    {voucher.discount}
                                  </td>
                                  <td className="xsm-text text-capitalize align-middle text-center">
                                    {voucher.prefix}
                                  </td>
                                  <td className="xsm-text text-capitalize align-middle text-center">
                                    {voucher.from_voucher}
                                  </td>
                                  <td className="xsm-text align-middle text-center">
                                    {voucher.to_voucher}
                                  </td>
                                  <td className="xsm-text text-capitalize align-middle text-center">
                                    {/* <div className="dropdown">
                                      <button
                                        className="btn t-bg-clear t-text-dark--light-40"
                                        type="button"
                                        data-toggle="dropdown"
                                      >
                                        <i className="fa fa-ellipsis-h"></i>
                                      </button>
                                      <div className="dropdown-menu">
                                        <button
                                          className="dropdown-item sm-text text-capitalize"
                                          onClick={() =>
                                            handleSetEdit(voucher)
                                          }
                                          data-toggle="modal"
                                          data-target="#addCard"
                                        >
                                          <span className="t-mr-8">
                                            <i className="fa fa-pencil"></i>
                                          </span>
                                          {_t(t("Edit"))}
                                        </button>
                                      </div>
                                    </div> */}
                                    <button
                                      className="btn btn-primary ml-2 rounded-sm del-btn"
                                      onClick={() => handleSetEdit(voucher)}
                                      data-toggle="modal"
                                      data-target="#addVoucher"
                                    >
                                      <i
                                        className="fa fa-pencil edit-icon"
                                        aria-hidden="true"
                                      ></i>
                                    </button>
                                    {/* <button
                                      className="btn btn-danger ml-2 rounded-sm del-btn"
                                      onClick={() =>
                                        handleDeleteConfirmation(voucher)
                                      }
                                    >
                                      <MdDelete className="del-icon" />
                                    </button> */}
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {newVoucher?.uploading === true || loading === true
                ? paginationLoading()
                : [
                    // logic === !searched
                    !searchedVoucher.searched ? (
                      <div key="fragment4">
                        <div className="t-bg-white mt-1 t-pt-5 t-pb-5">
                          <div className="row align-items-center t-pl-15 t-pr-15">
                            <div className="col-md-7 t-mb-15 mb-md-0">
                              {/* pagination function */}
                              {pagination(voucherList, setPaginatedVoucher)}
                            </div>
                            <div className="col-md-5">
                              <ul className="t-list d-flex justify-content-md-end align-items-center">
                                <li className="t-list__item">
                                  <span className="d-inline-block sm-text">
                                    {showingData(voucherList)}
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      // if searched
                      <div className="t-bg-white mt-1 t-pt-5 t-pb-5">
                        <div className="row align-items-center t-pl-15 t-pr-15">
                          <div className="col-md-7 t-mb-15 mb-md-0">
                            <ul className="t-list d-flex">
                              <li className="t-list__item no-pagination-style">
                                <button
                                  className="btn btn-primary btn-sm rounded"
                                  onClick={
                                    () => {}
                                    // setSearchedScheme({
                                    //   ...searchedScheme,
                                    //   searched: false,
                                    // })
                                  }
                                >
                                  {_t(t("Clear Search"))}
                                </button>
                              </li>
                            </ul>
                          </div>
                          <div className="col-md-5">
                            <ul className="t-list d-flex justify-content-md-end align-items-center">
                              <li className="t-list__item">
                                <span className="d-inline-block sm-text">
                                  {/* {searchedShowingData(
                                    searchedScheme,
                                    deptTagForSearch
                                  )} */}
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    ),
                  ]}
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default VoucherCrud;
